import React, { Component } from "react";
import ContentHeader from "./ContentHeader";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { list, create, update, search } from "../actions";
import { groupBy } from "lodash";
import moment from "moment";
import styled from "styled-components";
import { Colors } from "../utils/Colors";
import {isSunday} from '../utils/DateHelpers';

import { SLBTextarea, SLBTxtBox, SLBDatePicker } from "../utils/Forms";

const EditLink = styled.a``;

const MeditationItem = styled.div`
  padding: 8px;
  border-bottom: 1px solid ${Colors.panelBorderColor};
  display: flex;
  justify-content: space-between;
`;
const MeditationRow = ({ id, date, content, title, onEdit }) => {
  return (
    <MeditationItem>
      <span>
        {moment(date).format("MMM, DD")} - {title}
      </span>
      <EditLink
        href="#"
        onClick={e => {
          e.preventDefault();
          onEdit(id);
        }}
      >
        edit
      </EditLink>
    </MeditationItem>
  );
};

const Panel = styled.div`
  border: 1px solid ${Colors.panelBorderColor};
  width: 350px;
  height: 220px;
  margin-right: 30px;
  margin-bottom: 30px;
  float: left;
`;

const PanelHeader = styled.div`
  background-color: ${Colors.header};
  color: white;
  padding: 8px;
`;
const PanelBody = styled.div``;
const YearMonthFormater = "YYYY MMM";

const meditationSorter = (a, b) => a.date < b.date;
const meditationItemSorter = (a, b) => a.start_week_date < b.start_week_date;

class MeditationList extends Component {
  renderMeditations(meditations) {
    let groupedMeditations = groupBy(meditations, function(med) {
      return moment(med.start_week_date).format(YearMonthFormater);
    });

    let collection = [];
    for (let i in groupedMeditations) {
      const sorted = groupedMeditations[i].sort(meditationItemSorter);
      collection.push({
        group: i,
        meditations: sorted,
        date: moment(i, YearMonthFormater).toDate()
      });
    }

    return collection.sort(meditationSorter).map(row => {
      return (
        <Panel key={row.group}>
          <PanelHeader>{row.group}</PanelHeader>
          <PanelBody>
            {row.meditations.map(meditation => (
              <MeditationRow
                key={meditation.id}
                id={meditation.id}
                date={meditation.start_week_date}
                title={meditation.title}
                content={meditation.content}
                onEdit={this.props.onEdit}
              />
            ))}
          </PanelBody>
        </Panel>
      );
    });
  }

  render() {
    return (
      <div>
        {this.props.meditations &&
          this.renderMeditations(this.props.meditations)}
      </div>
    );
  }
}

class Meditation extends Component {
  componentDidMount() {
    this.props.fetchMeditations();
  }

  onEdit = id => {
    this.props.fetchMeditation(id);
  };

  render() {
    return (
      <div>
        <ContentHeader title="Meditation" />
        <div className="col-md-12">
          <div className="col-md-6">
            <MeditationList
              onEdit={this.onEdit}
              meditations={this.props.meditations}
            />
          </div>
          <div className="col-md-6">
            <MeditationForm
              saveMeditation={this.props.saveMeditation}
              currentMeditation={this.props.currentMeditation}
            />
          </div>
        </div>
      </div>
    );
  }
}

class MeditationForm extends Component {
  state = {
    errors: {},
    meditation: {}
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const data = Object.assign({}, nextProps.currentMeditation);
    this.setMeditation(data);
  }

  setMeditation(data = {}) {
    const meditation = {
      id: data.id || 0,
      title: data.title || "",
      content: data.content || "",
      start_week_date: data.start_week_date || moment()
    };

    this.setState({ meditation });
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    let newMeditation = { ...this.state.meditation, [name]: value };
    this.setState({ ...this.state, meditation: newMeditation });
  }

  isMeditationValid(meditation = {}) {
    let errors = {};
    const { title, content, start_week_date } = meditation;
    if (isEmpty(title)) {
      errors["title"] = "Title is required!";
    }

    if (isEmpty(content)) {
      errors["content"] = "Content is required!";
    }

    if (isEmpty(start_week_date)) {
      errors["start_week_date"] = "Start week date is required!";
    }
    this.setState({ errors });
    return isEmpty(errors);
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isMeditationValid(this.state.meditation)) {
      this.props.saveMeditation(this.state.meditation);
    }
  }

  meditationDateChanged = updatedDate => {
    let updatedMeditation = {
      ...this.state.meditation,
      start_week_date: updatedDate
    };
    this.setState({ meditation: updatedMeditation });
  };

  resetForm = () => {
    this.setMeditation({});
  };

  render() {
    const { id, start_week_date, title, content } = this.state.meditation;
    const { errors } = this.state;
    let buttonText = id > 0 ? "Update" : "Create";
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="col-md-12">
            <SLBDatePicker
              label="Start Week Date"
              name="start_week_date"
              value={start_week_date}
              handleChange={this.meditationDateChanged}
              attrs={{ errors, klass: "col-md-12" ,filterDate: isSunday }}
            />
          </div>
          <div className="col-md-12">
            <SLBTxtBox
              label="Title"
              name="title"
              value={title}
              context={this}
              attrs={{ errors, klass: "col-md-12"}}
            />
          </div>
          <div className="col-md-12">
            <SLBTextarea
              label="Content"
              name="content"
              value={content}
              context={this}
              attrs={{ errors, klass: "col-md-12", rows: "6" }}
            />
          </div>
          <br />
          <div className="col-md-12 edit-buttons-pane">
            <input
              className="btn btn-success pull-right"
              type="submit"
              value={buttonText}
            />
            <a
              className="btn btn-default pull-right"
              style={{ marginRight: 10 }}
              onClick={() => this.resetForm()}
            >
              Cancel
            </a>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { currentMeditation, list } = state.meditations;

  return {
    meditations: list,
    currentMeditation: currentMeditation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMeditations() {
      dispatch(list("meditations"));
    },
    fetchMonthlyMeditation(searchParams) {
      dispatch(search("meditations", searchParams));
    },
    fetchMeditation(id) {
      dispatch({ type: "FIND_MEDITATION", id });
    },
    saveMeditation(data) {
      if (data.id) {
        dispatch(update("meditation", data));
      } else {
        dispatch(create("meditation", data));
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Meditation);



// WEBPACK FOOTER //
// ./src/components/Meditation.js